import { useQueryClient, useMutation } from "@tanstack/react-query";
import { formatISO } from "date-fns";
import { useAppointmentsProvider } from "../providers/appointments-provider.js";
import { useAxiosProvider } from "../providers/axios-provider.js";
import "react/jsx-runtime";
import "react";
import "../appointment-schedule.constants.js";
import "../appointment-schedule.types.js";
import "../helpers/common.js";
import "date-fns/locale";
import "fast-memoize";
import "../helpers/getViewTimePeriod.js";
import "../helpers/groupBy.js";
import "../../../../utils/time/time.js";
import "lodash";
import "./useAppointments.js";
import "axios";
import "./useServerSentEvent.js";
import "../providers/working-times-provider.js";
import "../helpers/getEmptyCalendarSlots.js";
import "../helpers/fillEmptyDays.js";
import "./useWorkingTimes.js";
const editAppointment = (axios) => async (appointmentReferenceId, params) => {
  const { data } = await axios.put(
    `/api/v1/internal/appointments/${appointmentReferenceId ?? ""}`,
    params
  );
  return data;
};
const useSaveAppointment = () => {
  const { echoCore } = useAxiosProvider();
  const { queryKey } = useAppointmentsProvider();
  const queryClient = useQueryClient();
  const mutation = useMutation({
    onMutate: async (appointment) => {
      await queryClient.cancelQueries({ queryKey });
      const previousAppointments = queryClient.getQueryData(queryKey);
      queryClient.setQueryData(
        queryKey,
        (oldAppointments = []) => oldAppointments.map((current) => {
          if (current.referenceId === appointment.data.referenceId) {
            return {
              ...current,
              employeeReferenceId: appointment.data.practitionerReferenceId,
              practitionerReferenceId: appointment.data.practitionerReferenceId,
              // @ts-expect-error TODO:
              startTime: formatISO(appointment.data.start, { format: "extended" }),
              // @ts-expect-error TODO:
              endTime: formatISO(appointment.data.end, { format: "extended" })
            };
          }
          return current;
        })
      );
      return { previousAppointments };
    },
    onError: (_error, _newAppointment, context) => {
      queryClient.setQueryData(queryKey, context.previousAppointments);
    },
    mutationFn: ({ data }) => {
      const { referenceId, ...rest } = data;
      return editAppointment(echoCore)(referenceId, rest);
    }
  });
  return mutation;
};
export {
  useSaveAppointment
};
